import {environment} from '../../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CustomsValidators} from '../../validators/custom.validators';
import {throwError} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AspectsAdminService {
  urlTypeAdmin: string;

  constructor(private http: HttpClient) {
    this.urlTypeAdmin = `${environment.bffBaseUrl}/pages/admin-types`;
  }

  getAdmtypeList(page, limit) {
    const urlBuilder = this.urlTypeAdmin + '?page=' + page + '&limit=' + limit + '&desc=false';
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postAdmType(type) {
    const urlBuilder = this.urlTypeAdmin;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, {
      Name: type.Name,
      Description: type.Description
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  putAdmType(type) {
    const urlBuilder = this.urlTypeAdmin + '/' + type.id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder, {
      Id: type.id,
      Name: type.Name,
      Description: type.Description,
      IsEnabled: type.IsEnabled
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

}
